import React, {Component, ReactNode, RefObject} from 'react'
import {Nullable} from '../../app/TypeHelpers'
import {MeetingFile} from './model/MeetingFile'
import {MeetingRepositoryForAdmin} from './MeetingRepositoryForAdmin'
import {addEmptyData, NoSelectedValue} from '../../componentHelper/selectHelper'
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {RequiredChip, StyledTableCaption, TableRowName} from '../../styledComponents/adminPage/Table'
import PPTextField from '../shared/forms/PPTextField'
import PPDatePicker from '../shared/forms/PPDatePicker'
import {
    FlexContainer,
    FlexGrowContent,
    FullWidthLeftRowFlexContainer,
    FullWidthRightRowFlexContainer,
    LeftRowFlexContainer,
    LeftTopRowFlexContainer,
    RowFlexContainer,
    StretchColumnFlexContainer,
    TopRowFlexContainer,
} from '../../styledComponents/FlexComponents'
import PPSelect from '../shared/forms/PPSelect'
import {AVAILABLE_OR_NOT, HOURS, HOURS_24, RESERVATION_TIME_UNIT_MINUTES} from '../../CodeMaster'
import PPFileInput from '../shared/forms/PPFileInput'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import {DeleteLink, StyledLink} from '../../styledComponents/adminPage/Links'
import styled from 'styled-components'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {MeetingLink} from './model/MeetingLink'
import {downloadDataUriSchemeOnMsSaveBlob, getFileExtension} from '../../__NoAutomatedTests/common/util/Natutil'
import {isIE} from 'react-device-detect'
import {getLinkIconComponent} from './AssocDirectorCommon'
import {fromTimeToMoment} from '../../dateHelpers/MomentHelper'
import FormErrorMessage from '../shared/forms/FormErrorMessage'
import PPErrorLabel from '../shared/forms/PPErrorLabel'
import {StyledDiv} from '../../styledComponents/StyledTypeDefinitions'
import PPRadioGroup from '../shared/forms/PPRadioGroup'
import {AttachmentFileStyle} from './AdminMeetingListPage'
import {AddCircleOutline, RemoveCircleOutline} from '@mui/icons-material'
import {Colors} from '../../styledComponents/Constants'
import {AsyncCallFunctionType} from '../shared/hoc/withAsyncCommunication'
import {Messages} from '../../Messages'
import {RequestItemError} from '../../network/response/RequestItemError'
import {SelectChangeEvent} from '@mui/material/Select'

export interface AdminMeetingFormProps {
    name: string
    date: Nullable<Date>
    startHour: string
    startMinute: string
    endHour: string
    endMinute: string
    isErrorOfPeriod: boolean
    url: string
    place: string
    hasWebMeeting: boolean
    memo: string
    contents: string
    attendanceReplyDeadline: Nullable<Date>
    manageAttendance: boolean
    proxyAttendanceAvailability: Nullable<string>
    registeredMeetingFileList: MeetingFile[]
    registeredMeetingLinkList: MeetingLink[]
    registeredMeetingReportList: MeetingFile[]
    deleteMeetingFileNumberList: number[]
    deleteReportNumberList: number[]
    version: number
}

interface Props {
    condominiumCd: string
    meetingRepoForAdmin: MeetingRepositoryForAdmin
    meetingDataSet: AdminMeetingFormProps
    eventEmitter: EventEmitterExAdmin
    asyncCallFunction: AsyncCallFunctionType
    onChange?: (value: AdminMeetingFormProps) => void
}

interface State {
    meetingFileName: string
    meetingFileSize: number
    meetingFileData: string | null
    meetingLinkName: string
    meetingLinkUrl: string
    isAttachmentOpen: boolean
    attachmentType: ATTACHMENT_TYPE
    meetingReportName: string
    meetingReportSize: number
    meetingReportData: string | null
    isReportOpen: boolean
    hasMeetingFileError: boolean
    hasMeetingReportError: boolean
}

enum ATTACHMENT_TYPE {
    FILE,
    LINK,
}

export class AdminMeetingForm extends Component<Props, State> {
    meetingFileRef: RefObject<HTMLInputElement>
    meetingReportRef: RefObject<HTMLInputElement>

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            meetingFileName: '',
            meetingFileSize: 0,
            meetingFileData: '',
            meetingLinkName: '',
            meetingLinkUrl: '',
            isAttachmentOpen: false,
            attachmentType: ATTACHMENT_TYPE.FILE,
            meetingReportName: '',
            meetingReportSize: 0,
            meetingReportData: '',
            isReportOpen: false,
            hasMeetingFileError: false,
            hasMeetingReportError: false,
        }

        this.meetingFileRef = React.createRef()
        this.meetingReportRef = React.createRef()

        this.handleChangeName = this.handleChangeName.bind(this)
        this.handleChangeDate = this.handleChangeDate.bind(this)
        this.handleChangeStartHour = this.handleChangeStartHour.bind(this)
        this.handleChangeStartMinute = this.handleChangeStartMinute.bind(this)
        this.handleChangeEndHour = this.handleChangeEndHour.bind(this)
        this.handleChangeEndMinute = this.handleChangeEndMinute.bind(this)
        this.handleChangeMemo = this.handleChangeMemo.bind(this)
        this.handleChangeDescription = this.handleChangeDescription.bind(this)
        this.handleChangeCheckWebMeeting = this.handleChangeCheckWebMeeting.bind(this)
        this.handleChangeUrl = this.handleChangeUrl.bind(this)
        this.handleChangeMeetingRoom = this.handleChangeMeetingRoom.bind(this)
        this.handleChangeCheckManageAttendance = this.handleChangeCheckManageAttendance.bind(this)
        this.handleChangeAttendanceReplyDeadline = this.handleChangeAttendanceReplyDeadline.bind(this)
        this.handleChangeProxyAttendanceAvailability = this.handleChangeProxyAttendanceAvailability.bind(this)
        this.handleChangeMeetingFile = this.handleChangeMeetingFile.bind(this)
        this.handleChangeMeetingReport = this.handleChangeMeetingReport.bind(this)
        this.handleAddMeetingAttachment = this.handleAddMeetingAttachment.bind(this)
        this.handleAddMeetingReport = this.handleAddMeetingReport.bind(this)
        this.handleDeleteMeetingFile = this.handleDeleteMeetingFile.bind(this)
        this.handleDeleteMeetingLink = this.handleDeleteMeetingLink.bind(this)
        this.handleDeleteMeetingReport = this.handleDeleteMeetingReport.bind(this)
        this.handleAttachmentOpenClick = this.handleAttachmentOpenClick.bind(this)
        this.handleAttachmentCloseClick = this.handleAttachmentCloseClick.bind(this)
        this.handleReportOpenClick = this.handleReportOpenClick.bind(this)
        this.handleReportCloseClick = this.handleReportCloseClick.bind(this)
        this.handleChangeAttachmentTypeRadio = this.handleChangeAttachmentTypeRadio.bind(this)
        this.handleChangeMeetingLinkName = this.handleChangeMeetingLinkName.bind(this)
        this.handleChangeMeetingLinkUrl = this.handleChangeMeetingLinkUrl.bind(this)
    }

    callOnChange(updatePartialObject: Partial<AdminMeetingFormProps>): void {
        if (this.props.onChange) {
            this.props.onChange({
                ...this.props.meetingDataSet,
                ...updatePartialObject,
            })
        }
    }

    handleChangeName(event: React.ChangeEvent<HTMLInputElement>): void {
        const name = event.target.value
        this.callOnChange({name})
    }

    handleChangeDate(date: Nullable<Date>): void {
        this.callOnChange({date})
    }

    handleChangeStartHour(event: SelectChangeEvent<unknown>): void {
        const newStartHour = event.target.value as string
        const {startMinute, endHour, endMinute} = this.props.meetingDataSet
        const isErrorOfPeriod = this.isErrorOfPeriod(newStartHour, startMinute, endHour, endMinute)

        this.callOnChange({startHour: newStartHour, isErrorOfPeriod})
    }

    handleChangeStartMinute(event: SelectChangeEvent<unknown>): void {
        const newStartMinute = event.target.value as string
        const {startHour, endHour, endMinute} = this.props.meetingDataSet
        const isErrorOfPeriod = this.isErrorOfPeriod(startHour, newStartMinute, endHour, endMinute)

        this.callOnChange({startMinute: newStartMinute, isErrorOfPeriod})
    }

    handleChangeEndHour(event: SelectChangeEvent<unknown>): void {
        const newEndHour = event.target.value as string
        const {startHour, startMinute, endMinute} = this.props.meetingDataSet
        let newEndMinute = endMinute
        if (newEndHour === HOURS_24.VOL_24.value) {
            newEndMinute = RESERVATION_TIME_UNIT_MINUTES.VOL_0.value
        }
        const isErrorOfPeriod = this.isErrorOfPeriod(startHour, startMinute, newEndHour, newEndMinute)

        this.callOnChange({
            endHour: newEndHour,
            endMinute: newEndMinute,
            isErrorOfPeriod,
        })
    }

    handleChangeEndMinute(event: SelectChangeEvent<unknown>): void {
        const newEndMinute = event.target.value as string
        const {startHour, startMinute, endHour} = this.props.meetingDataSet
        const isErrorOfPeriod = this.isErrorOfPeriod(startHour, startMinute, endHour, newEndMinute)

        this.callOnChange({endMinute: newEndMinute, isErrorOfPeriod})
    }

    isErrorOfPeriod(startHour: string, startMinute: string, endHour: string, endMinute: string): boolean {
        if (
            startHour === NoSelectedValue ||
            startMinute === NoSelectedValue ||
            endHour === NoSelectedValue ||
            endMinute === NoSelectedValue
        ) {
            return false
        }

        const startTime = fromTimeToMoment(startHour, startMinute)
        const endTime = fromTimeToMoment(endHour, endMinute)
        return !startTime.isBefore(endTime)
    }

    handleChangeMemo(event: React.ChangeEvent<HTMLInputElement>): void {
        const memo = event.target.value
        this.callOnChange({memo})
    }

    handleChangeDescription(event: React.ChangeEvent<HTMLInputElement>): void {
        const contents = event.target.value
        this.callOnChange({contents})
    }

    handleChangeCheckWebMeeting(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void {
        const hasWebMeeting = checked
        this.callOnChange({hasWebMeeting})
    }

    handleChangeUrl(event: React.ChangeEvent<HTMLInputElement>): void {
        const url = event.target.value
        this.callOnChange({url})
    }

    handleChangeMeetingRoom(event: React.ChangeEvent<HTMLInputElement>): void {
        const place = event.target.value
        this.callOnChange({place})
    }

    handleChangeCheckManageAttendance(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void {
        const manageAttendance = checked
        this.callOnChange({manageAttendance})
    }

    handleChangeAttendanceReplyDeadline(attendanceReplyDeadline: Nullable<Date>): void {
        this.callOnChange({attendanceReplyDeadline})
    }

    handleChangeProxyAttendanceAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        const proxyAttendanceAvailability = event.target.value
        this.callOnChange({proxyAttendanceAvailability})
    }

    checkFileSize(fileSize: number): Nullable<string> {
        if (fileSize > (20 * 1024 * 1024)) {
            return 'アップロードファイルの上限サイズは1ファイルあたり20MBまでです'
        }
        if (fileSize === 0) {
            return '空のファイルをアップロードすることはできません'
        }
        return null
    }

    handleChangeMeetingFile(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            const file = event.target.files[0]
            const fileError = this.checkFileSize(file.size)
            if (fileError) {
                this.props.eventEmitter.emit(
                    'meetingFile',
                    new RequestItemError(
                        'meetingFile',
                        fileError,
                        '',
                    ))
            }
            this.setState({
                meetingFileName: file.name,
                meetingFileSize: file.size,
                meetingFileData: '',
                hasMeetingFileError: fileError !== null,
            }, () => {
                const reader: FileReader = new FileReader()
                reader.onload = () => {
                    this.setState({meetingFileData: String(reader.result)})
                }
                reader.onerror = () => {
                    this.setState({
                        meetingFileName: '',
                        meetingFileSize: 0,
                        meetingFileData: '',
                        hasMeetingFileError: true,
                    })
                    this.props.eventEmitter.emit(
                        'meetingFile',
                        new RequestItemError(
                            'meetingFile',
                            'ファイルの読み込みに失敗しました。もう一度ファイルを選択してください。',
                            '',
                        ))
                }
                reader.readAsDataURL(file)
            })
        } else {
            this.setState({
                meetingFileName: '',
                meetingFileSize: 0,
                meetingFileData: '',
                hasMeetingFileError: false,
            })
        }
    }

    handleChangeMeetingReport(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            const file = event.target.files[0]
            const fileError = this.checkFileSize(file.size)
            if (fileError) {
                this.props.eventEmitter.emit(
                    'meetingReport',
                    new RequestItemError(
                        'meetingReport',
                        fileError,
                        '',
                    ))
            }
            this.setState({
                meetingReportName: file.name,
                meetingReportSize: file.size,
                meetingReportData: '',
                hasMeetingReportError: fileError !== null,
            }, () => {
                const reader: FileReader = new FileReader()
                reader.onloadend = () => {
                    this.setState({meetingReportData: String(reader.result)})
                }
                reader.onerror = () => {
                    this.setState({
                        meetingReportName: '',
                        meetingReportSize: 0,
                        meetingReportData: '',
                        hasMeetingReportError: true,
                    })
                    this.props.eventEmitter.emit(
                        'meetingReport',
                        new RequestItemError(
                            'meetingReport',
                            'ファイルの読み込みに失敗しました。もう一度ファイルを選択してください。',
                            '',
                        ))
                }
                reader.readAsDataURL(file)
            })
        } else {
            this.setState({
                meetingReportName: '',
                meetingReportSize: 0,
                meetingReportData: '',
                hasMeetingReportError: false,
            })
        }
    }

    async handleAddMeetingAttachment(): Promise<void> {
        const {attachmentType} = this.state
        if (attachmentType === ATTACHMENT_TYPE.FILE) {
            this.addMeetingFile()
        } else {
            await this.addMeetingLink()
        }
    }

    handleAddMeetingReport(): void {
        const meetingReport: MeetingFile = {
            fileNumber: null,
            fileName: this.state.meetingReportName,
            fileSize: this.state.meetingReportSize,
            fileData: this.state.meetingReportData,
        }

        this.closeReportForms()

        this.callOnChange({
            registeredMeetingReportList: [
                ...this.props.meetingDataSet.registeredMeetingReportList,
                meetingReport,
            ],
        })
    }

    addMeetingFile(): void {
        const meetingFile: MeetingFile = {
            fileNumber: null,
            fileName: this.state.meetingFileName,
            fileSize: this.state.meetingFileSize,
            fileData: this.state.meetingFileData,
        }

        this.closeAttachmentForms()

        this.callOnChange({
            registeredMeetingFileList: [
                ...this.props.meetingDataSet.registeredMeetingFileList,
                meetingFile,
            ],
        })
    }

    async addMeetingLink(): Promise<void> {
        const meetingLink: MeetingLink = {
            linkId: null,
            linkName: this.state.meetingLinkName,
            linkUrl: this.state.meetingLinkUrl,
        }

        const {asyncCallFunction, meetingRepoForAdmin, eventEmitter} = this.props
        const validateResult = await asyncCallFunction(
            meetingRepoForAdmin.validateMeetingLink.bind(meetingRepoForAdmin, meetingLink),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
            {defaultErrorTitle: Messages.EOPCA0003.toString('Webサイト')},
        )

        if (validateResult === null) {
            return
        }

        this.closeAttachmentForms()

        this.callOnChange({
            registeredMeetingLinkList: [
                ...this.props.meetingDataSet.registeredMeetingLinkList,
                meetingLink,
            ],
        })
    }

    closeAttachmentForms(): void {
        if (this.meetingFileRef.current && this.meetingFileRef.current.value) {
            this.meetingFileRef.current.value = ''
        }

        this.setState({
            meetingFileName: '',
            meetingFileSize: 0,
            meetingFileData: null,
            meetingLinkName: '',
            meetingLinkUrl: '',
            isAttachmentOpen: false,
            attachmentType: ATTACHMENT_TYPE.FILE,
            hasMeetingFileError: false,
        })
    }

    closeReportForms(): void {
        if (this.meetingReportRef.current && this.meetingReportRef.current.value) {
            this.meetingReportRef.current.value = ''
        }

        this.setState({
            meetingReportName: '',
            meetingReportSize: 0,
            meetingReportData: null,
            isReportOpen: false,
            hasMeetingReportError: false,
        })
    }

    handleDeleteMeetingFile(index: number): void {
        const {registeredMeetingFileList, deleteMeetingFileNumberList} = this.props.meetingDataSet
        const meetingFileList: MeetingFile[] = []

        for (let i: number = 0; i < registeredMeetingFileList.length; i++) {
            const meetingFile = registeredMeetingFileList[i]
            if (index !== i) {
                meetingFileList.push(meetingFile)
            } else if (meetingFile.fileNumber) {
                deleteMeetingFileNumberList.push(meetingFile.fileNumber)
            }
        }

        this.callOnChange({
            registeredMeetingFileList: meetingFileList,
            deleteMeetingFileNumberList: deleteMeetingFileNumberList,
        })
    }

    handleDeleteMeetingLink(index: number): void {
        const {registeredMeetingLinkList} = this.props.meetingDataSet
        const meetingLinkList: MeetingLink[] = []

        for (let i: number = 0; i < registeredMeetingLinkList.length; i++) {
            if (index !== i) {
                meetingLinkList.push(registeredMeetingLinkList[i])
            }
        }

        this.callOnChange({registeredMeetingLinkList: meetingLinkList})
    }

    handleDeleteMeetingReport(index: number): void {
        const {registeredMeetingReportList, deleteReportNumberList} = this.props.meetingDataSet
        const meetingReportList: MeetingFile[] = []

        for (let i: number = 0; i < registeredMeetingReportList.length; i++) {
            const meetingReport = registeredMeetingReportList[i]
            if (index !== i) {
                meetingReportList.push(meetingReport)
            } else if (meetingReport.fileNumber) {
                deleteReportNumberList.push(meetingReport.fileNumber)
            }
        }

        this.callOnChange({
            registeredMeetingReportList: meetingReportList,
            deleteReportNumberList: deleteReportNumberList,
        })
    }

    handleAttachmentOpenClick(): void {
        const isAttachmentOpen = true
        this.setState({isAttachmentOpen})
    }

    handleAttachmentCloseClick(): void {
        this.closeAttachmentForms()
    }

    handleReportOpenClick(): void {
        const isReportOpen = true
        this.setState({isReportOpen})
    }

    handleReportCloseClick(): void {
        this.closeReportForms()
    }

    handleChangeAttachmentTypeRadio(event: React.ChangeEvent<HTMLInputElement>): void {
        const attachmentType = Number(event.target.value)
        this.setState({attachmentType})
    }

    handleChangeMeetingLinkName(event: React.ChangeEvent<HTMLInputElement>): void {
        const meetingLinkName = event.target.value
        this.setState({meetingLinkName})
    }

    handleChangeMeetingLinkUrl(event: React.ChangeEvent<HTMLInputElement>): void {
        const meetingLinkUrl = event.target.value
        this.setState({meetingLinkUrl})
    }

    getFileLinkFromBlob(meetingFile: MeetingFile): ReactNode {
        const {fileName, fileData} = meetingFile
        if (fileData === null) {
            return null
        }

        const icon = getLinkIconComponent(getFileExtension(fileName))
        if (isIE) {
            return <StyledLink href="javascript:void(0)" onClick={
                () => downloadDataUriSchemeOnMsSaveBlob(String(fileData), fileName)
            }>
                <AttachmentFileStyle>{icon}</AttachmentFileStyle>
                {fileName}
            </StyledLink>
        } else {
            return <StyledLink href={String(fileData)} download={fileName}>
                <AttachmentFileStyle>{icon}</AttachmentFileStyle>
                {fileName}
            </StyledLink>
        }
    }

    getLink(linkName: string, url: string, fileExtension: string = 'NONE'): ReactNode {
        const icon = getLinkIconComponent(fileExtension)
        const linkContent = <>
            <AttachmentFileStyle>{icon}</AttachmentFileStyle>{linkName}
        </>
        if (fileExtension === 'NONE') {
            return <StyledLink href={url} target={'_blank'} rel={'noopener noreferrer'}>{linkContent}</StyledLink>
        } else {
            return <StyledLink href={url} download>{linkContent}</StyledLink>
        }
    }

    renderMeetingFileRecord(meetingFile: MeetingFile, index: number): ReactNode {
        return <TableRow key={`file-${index}`}>
            <MeetingAttachmentTableCell>
                <FlexContainer>
                    <FileOrLinkNameStyle>
                        {this.getFileLinkFromBlob(meetingFile)}
                    </FileOrLinkNameStyle>
                    <NoShrinkDeleteLink onClick={(event: React.MouseEvent) => {
                        event.preventDefault()
                        this.handleDeleteMeetingFile(index)
                    }}>
                        削除
                    </NoShrinkDeleteLink>
                </FlexContainer>
                <PPErrorLabel
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={[`attachmentFiles[${index}]`]}
                />
            </MeetingAttachmentTableCell>
        </TableRow>
    }

    renderLinkRecord(linkName: string, url: string, index: number): ReactNode {
        return <TableRow key={`link-${index}`}>
            <MeetingAttachmentTableCell>
                <FlexContainer>
                    <FileOrLinkNameStyle>
                        {this.getLink(linkName, url)}
                    </FileOrLinkNameStyle>
                    <DeleteLink onClick={(event: React.MouseEvent) => {
                        event.preventDefault()
                        this.handleDeleteMeetingLink(index)
                    }}>
                        削除
                    </DeleteLink>
                </FlexContainer>
                <PPErrorLabel
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={[`meetingAttachmentLinkList[${index}].linkName`]}
                />
                <PPErrorLabel
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={[`meetingAttachmentLinkList[${index}].url`]}
                />
            </MeetingAttachmentTableCell>
        </TableRow>
    }

    renderMeetingReportRecord(meetingFile: MeetingFile, index: number): ReactNode {
        return <TableRow key={`report-${index}`}>
            <MeetingAttachmentTableCell>
                <FlexContainer>
                    <FileOrLinkNameStyle>
                        {this.getFileLinkFromBlob(meetingFile)}
                    </FileOrLinkNameStyle>
                    <NoShrinkDeleteLink onClick={(event: React.MouseEvent) => {
                        event.preventDefault()
                        this.handleDeleteMeetingReport(index)
                    }}>
                        削除
                    </NoShrinkDeleteLink>
                </FlexContainer>
                <PPErrorLabel
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={[`reports[${index}]`]}
                />
            </MeetingAttachmentTableCell>
        </TableRow>
    }

    renderAttachmentOpenOrCloseLink(): ReactNode {
        return this.state.isAttachmentOpen ?
            <StyledLink onClick={this.handleAttachmentCloseClick}>
                <RemoveCircleOutline style={circleIconStyle}/>資料追加をやめる
            </StyledLink>
            :
            <StyledLink onClick={this.handleAttachmentOpenClick}>
                <AddCircleOutline style={circleIconStyle}/>資料を追加する
            </StyledLink>
    }

    renderReportOpenOrCloseLink(): ReactNode {
        return this.state.isReportOpen ?
            <StyledLink onClick={this.handleReportCloseClick}>
                <RemoveCircleOutline style={circleIconStyle}/>議事録追加をやめる
            </StyledLink>
            :
            <StyledLink onClick={this.handleReportOpenClick}>
                <AddCircleOutline style={circleIconStyle}/>議事録を追加する
            </StyledLink>
    }

    render(): ReactNode {
        const {
            name,
            date,
            startHour,
            startMinute,
            endHour,
            endMinute,
            isErrorOfPeriod,
            place,
            url,
            hasWebMeeting,
            memo,
            contents,
            attendanceReplyDeadline,
            manageAttendance,
            proxyAttendanceAvailability,
            registeredMeetingFileList,
            registeredMeetingLinkList,
            registeredMeetingReportList,
        } = this.props.meetingDataSet

        const {
            isAttachmentOpen,
            attachmentType,
            meetingLinkName,
            meetingLinkUrl,
            meetingFileData,
            meetingReportName,
            meetingReportData,
            isReportOpen,
            hasMeetingFileError,
            hasMeetingReportError,
        } = this.state

        const unsetDate: boolean = !date
        const disabledAttachmentFileForm: boolean = attachmentType !== ATTACHMENT_TYPE.FILE
        const disabledAttachmentLinkForm: boolean = attachmentType !== ATTACHMENT_TYPE.LINK
        const canAddFile: boolean = (
            !disabledAttachmentFileForm &&
            meetingFileData !== null &&
            meetingFileData !== '' &&
            !hasMeetingFileError
        )
        const canAddLink: boolean = (!disabledAttachmentLinkForm && meetingLinkName !== '' && meetingLinkUrl !== '')
        const canAddReference: boolean = canAddFile || canAddLink
        const canAddReport: boolean = (
            meetingReportData !== null &&
            meetingReportData !== '' &&
            !hasMeetingReportError
        )

        return <>
            <Table>
                <StyledTableCaption>開催要項</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName required>会議名</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 35,
                                    },
                                }}
                                value={name}
                                autoFocus
                                onChange={this.handleChangeName}
                                eventKeys={['name']}
                                eventEmitter={this.props.eventEmitter}
                                fullWidth
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>開催日</TableRowName>
                        <TableCell style={{paddingBottom: 19, paddingTop: 21}}>
                            <Box width={'200px'}>
                                <PPDatePicker
                                    value={date}
                                    onChangeDate={this.handleChangeDate}
                                />
                            </Box>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>開催時間</TableRowName>
                        <TableCell>
                            <StretchColumnFlexContainer>
                                <FullWidthLeftRowFlexContainer>
                                    <div>
                                        <RowFlexContainer>
                                            <div>
                                                <PPSelect
                                                    data={addEmptyData(HOURS.values())}
                                                    value={startHour}
                                                    onChange={this.handleChangeStartHour}
                                                    disabled={unsetDate}
                                                    sx={{
                                                        '& .MuiInputBase-input.Mui-disabled': {
                                                            backgroundColor: '#DDD',
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div>：</div>
                                            <div>
                                                <PPSelect
                                                    data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES.values())}
                                                    value={startMinute}
                                                    onChange={this.handleChangeStartMinute}
                                                    disabled={unsetDate}
                                                    sx={{
                                                        '& .MuiInputBase-input.Mui-disabled': {
                                                            backgroundColor: '#DDD',
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </RowFlexContainer>
                                    </div>
                                    <div>〜</div>
                                    <div>
                                        <RowFlexContainer>
                                            <div>
                                                <PPSelect
                                                    data={addEmptyData(HOURS_24.values())}
                                                    value={endHour}
                                                    onChange={this.handleChangeEndHour}
                                                    disabled={unsetDate}
                                                    sx={{
                                                        '& .MuiInputBase-input.Mui-disabled': {
                                                            backgroundColor: '#DDD',
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div>：</div>
                                            <div>
                                                <PPSelect
                                                    data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES.values())}
                                                    value={endMinute}
                                                    disabled={unsetDate || endHour === HOURS_24.VOL_24.value}
                                                    onChange={this.handleChangeEndMinute}
                                                    sx={{
                                                        '& .MuiInputBase-input.Mui-disabled': {
                                                            backgroundColor: '#DDD',
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </RowFlexContainer>
                                    </div>
                                </FullWidthLeftRowFlexContainer>

                                <FormErrorMessage messages={
                                    isErrorOfPeriod ? [{message: '開始時間が終了時間以降の時間になっています。'}] : undefined
                                }/>
                            </StretchColumnFlexContainer>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>開催場所</TableRowName>
                        <TableCell>
                            <Box mb={'10px'}>
                                <PPTextField
                                    value={place}
                                    onChange={this.handleChangeMeetingRoom}
                                    placeholder={'会議の開催場所名を入力してください。'}
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    eventKeys={['place']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </Box>
                            <FullWidthLeftRowFlexContainer>
                                <Box mr={'10px'}>
                                    <MediumSizeFormControlLabel
                                        label={'オンライン会議を設定する'}
                                        control={(
                                            <Checkbox
                                                color="primary"
                                                checked={hasWebMeeting}
                                                onChange={this.handleChangeCheckWebMeeting}
                                            />
                                        )}
                                    />
                                </Box>
                                <GrowableFormControl disabled={!hasWebMeeting}>
                                    <NoWrapFullWidthLeftRowFlexContainer>
                                        <MyFormLabel>
                                            <OnlineUrlItemName>
                                                URL
                                                <MyRequiredChip label={'必須'} disabled={!hasWebMeeting}
                                                                style={{width: `44px`}}
                                                />
                                            </OnlineUrlItemName>
                                        </MyFormLabel>
                                        <GrowableBox>
                                            <PPTextField
                                                value={url}
                                                onChange={this.handleChangeUrl}
                                                placeholder={'作成済みの会議のURLを入力してください。'}
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 2000,
                                                    },
                                                }}
                                                fullWidth
                                                disabled={!hasWebMeeting}
                                                eventKeys={['url']}
                                                eventEmitter={this.props.eventEmitter}
                                                sx={{
                                                    '& .MuiInputBase-input.Mui-disabled': {
                                                        backgroundColor: '#DDD',
                                                    },
                                                }}
                                            />
                                        </GrowableBox>
                                    </NoWrapFullWidthLeftRowFlexContainer>
                                </GrowableFormControl>
                            </FullWidthLeftRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Box mb={'16px'}>補足事項</Box>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 500,
                                        minRows: 5,
                                    },
                                }}
                                value={memo}
                                fullWidth
                                multiline
                                onChange={this.handleChangeMemo}
                                placeholder={'メンバーに事前に伝えておきたい注意点や補足事項を記入することができます。'}
                                eventKeys={['memo']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <StyledTableCaption>議題・アジェンダ</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 2000,
                                        minRows: 5,
                                    },
                                }}
                                value={contents}
                                fullWidth
                                multiline
                                onChange={this.handleChangeDescription}
                                eventKeys={['contents']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <StyledTableCaption>資料</StyledTableCaption>
                <TableBody>
                    {registeredMeetingFileList.map(
                        (meetingFile, index) =>
                            this.renderMeetingFileRecord(meetingFile, index),
                    )}
                    {registeredMeetingLinkList.map(
                        (meetingLink, index) =>
                            this.renderLinkRecord(meetingLink.linkName, meetingLink.linkUrl, index),
                    )}
                    <TableRow>
                        <AddMeetingAttachmentTableCell>
                            {this.renderAttachmentOpenOrCloseLink()}
                            {
                                isAttachmentOpen && <>
                                    <RadioGroup
                                        value={attachmentType}
                                        onChange={this.handleChangeAttachmentTypeRadio}
                                    >
                                        <MeetingAttachmentItem>
                                            <MediumSizeFormControlLabel
                                                value={ATTACHMENT_TYPE.FILE}
                                                control={<Radio color={'primary'}/>}
                                                label={'ファイルをアップロードする(20MBまで)'}
                                            />
                                            <FlexGrowContent>
                                                <Box mt={'6px'}>
                                                    <PPFileInput
                                                        InputProps={{
                                                            inputProps: {
                                                                id: 'meetingFile',
                                                                name: 'meetingFile',
                                                            },
                                                        }}
                                                        fullWidth
                                                        inputRef={this.meetingFileRef}
                                                        onChange={this.handleChangeMeetingFile}
                                                        fileName={this.state.meetingFileName}
                                                        id={'file'}
                                                        eventKeys={['meetingFile']}
                                                        eventEmitter={this.props.eventEmitter}
                                                        disabled={disabledAttachmentFileForm}
                                                    />
                                                </Box>
                                            </FlexGrowContent>
                                        </MeetingAttachmentItem>

                                        <MeetingAttachmentItem>
                                            <MediumSizeFormControlLabel
                                                value={ATTACHMENT_TYPE.LINK}
                                                control={<Radio color={'primary'}/>}
                                                label={'Webサイトを掲載する'}
                                            />
                                            <SecondaryGrowLabel>
                                                <LeftTopRowFlexContainer>
                                                    <Box mt={'5px'}>表示名：</Box>
                                                    <GrowableBox>
                                                        <PPTextField
                                                            value={this.state.meetingLinkName}
                                                            onChange={this.handleChangeMeetingLinkName}
                                                            InputProps={{
                                                                inputProps: {
                                                                    maxLength: 50,
                                                                },
                                                            }}
                                                            fullWidth
                                                            disabled={disabledAttachmentLinkForm}
                                                            eventEmitter={this.props.eventEmitter}
                                                            eventKeys={['linkName']}
                                                        />
                                                    </GrowableBox>
                                                </LeftTopRowFlexContainer>
                                            </SecondaryGrowLabel>
                                            <PrimaryGrowLabel>
                                                <LeftTopRowFlexContainer>
                                                    <Box mt={'5px'}>URL：</Box>
                                                    <GrowableBox>
                                                        <PPTextField
                                                            value={this.state.meetingLinkUrl}
                                                            onChange={this.handleChangeMeetingLinkUrl}
                                                            InputProps={{
                                                                inputProps: {
                                                                    maxLength: 2000,
                                                                },
                                                            }}
                                                            fullWidth
                                                            disabled={disabledAttachmentLinkForm}
                                                            eventEmitter={this.props.eventEmitter}
                                                            eventKeys={['linkUrl']}
                                                        />
                                                    </GrowableBox>
                                                </LeftTopRowFlexContainer>
                                            </PrimaryGrowLabel>
                                        </MeetingAttachmentItem>
                                    </RadioGroup>
                                    <Box height={'8px'}/>
                                    <FullWidthRightRowFlexContainer>
                                        <AdminPrimaryButton
                                            onClick={this.handleAddMeetingAttachment}
                                            disabled={!canAddReference}
                                        >
                                            追加する
                                        </AdminPrimaryButton>
                                    </FullWidthRightRowFlexContainer>
                                </>
                            }
                        </AddMeetingAttachmentTableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <StyledTableCaption>議事録</StyledTableCaption>
                <TableBody>
                    {registeredMeetingReportList.map(
                        (meetingFile, index) =>
                            this.renderMeetingReportRecord(meetingFile, index),
                    )}
                    <TableRow>
                        <AddMeetingAttachmentTableCell>
                            {this.renderReportOpenOrCloseLink()}
                            {
                                isReportOpen && <>
                                    <MeetingAttachmentItem>
                                        <Box mr={'16px'} lineHeight={'42px'}>ファイルをアップロードする(20MBまで)</Box>
                                        <FlexGrowContent>
                                            <Box mt={'6px'}>
                                                <PPFileInput
                                                    InputProps={{
                                                        inputProps: {
                                                            id: 'meetingReport',
                                                            name: 'meetingReport',
                                                        },
                                                    }}
                                                    fullWidth
                                                    inputRef={this.meetingReportRef}
                                                    onChange={this.handleChangeMeetingReport}
                                                    fileName={meetingReportName}
                                                    id={'report'}
                                                    eventKeys={['meetingReport']}
                                                    eventEmitter={this.props.eventEmitter}
                                                />
                                            </Box>
                                        </FlexGrowContent>
                                    </MeetingAttachmentItem>
                                    <Box height={'8px'}/>
                                    <FullWidthRightRowFlexContainer>
                                        <AdminPrimaryButton
                                            onClick={this.handleAddMeetingReport}
                                            disabled={!canAddReport}
                                        >
                                            追加する
                                        </AdminPrimaryButton>
                                    </FullWidthRightRowFlexContainer>
                                </>
                            }
                        </AddMeetingAttachmentTableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <StyledTableCaption>出欠確認</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <LeftTopRowFlexContainer>
                                <Box width={'240px'}>
                                    <MediumSizeFormControlLabel
                                        label={'出欠確認機能を利用する'}
                                        control={(
                                            <Checkbox
                                                color="primary"
                                                checked={manageAttendance}
                                                onChange={this.handleChangeCheckManageAttendance}
                                                disabled={unsetDate}
                                            />
                                        )}
                                    />
                                </Box>
                                <Box>
                                    <FormControl variant="standard" disabled={unsetDate || !manageAttendance}>
                                        <LeftRowFlexContainer>
                                            <MyFormLabel>
                                                <SubTableRowName>
                                                    回答期限
                                                    <MyRequiredChip label={'必須'}
                                                                    disabled={unsetDate || !manageAttendance}
                                                                    style={{width: '44px'}}
                                                    />
                                                </SubTableRowName>
                                            </MyFormLabel>
                                            <PPDatePicker
                                                disabled={unsetDate || !manageAttendance}
                                                value={attendanceReplyDeadline}
                                                maxDate={date}
                                                onChangeDate={this.handleChangeAttendanceReplyDeadline}
                                                eventKeys={['attendanceReplyDeadline']}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                        </LeftRowFlexContainer>
                                        <LeftRowFlexContainer>
                                            <MyFormLabel>
                                                <SubTableRowName>
                                                    代理出席
                                                    <MyRequiredChip label={'必須'}
                                                                    disabled={unsetDate || !manageAttendance}
                                                                    style={{width: '44px'}}
                                                    />
                                                </SubTableRowName>
                                            </MyFormLabel>
                                            <PPRadioGroup
                                                row
                                                data={[
                                                    {label: '許可する', value: AVAILABLE_OR_NOT.AVAILABLE.value},
                                                    {label: '許可しない', value: AVAILABLE_OR_NOT.UNAVAILABLE.value},
                                                ]}
                                                value={proxyAttendanceAvailability}
                                                onChange={this.handleChangeProxyAttendanceAvailability}
                                            />
                                        </LeftRowFlexContainer>
                                        <LeftRowFlexContainer>
                                            <Box width={'150px'}/>
                                            <SmallMyFormLabel>
                                                ※許可した場合、出欠回答時の選択肢として「出席」「欠席」の他に「代理出席」が追加されます。
                                            </SmallMyFormLabel>
                                        </LeftRowFlexContainer>
                                    </FormControl>
                                </Box>
                            </LeftTopRowFlexContainer>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>;
    }
}

const NoShrinkDeleteLink = styled(DeleteLink)`
  flex-shrink: 0;
`

const NoWrapFullWidthLeftRowFlexContainer = styled(FullWidthLeftRowFlexContainer)`
  white-space: nowrap;
`

const MediumSizeFormControlLabel = withStyles({
    label: {
        fontSize: '1em',
    },
})(FormControlLabel)

const GrowableBox = styled(Box)`
  flex-grow: 1;
`

const PrimaryGrowLabel = styled.label`
  flex-grow: 2;
  margin-top: 5px;
`
const SecondaryGrowLabel = styled.label`
  flex-grow: 1;
  margin-right: 16px;
  margin-top: 5px;
`

export const FileOrLinkNameStyle: StyledDiv = styled.div`
  overflow-wrap: anywhere;
`

const MyFormLabel = withStyles({
    root: {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
        '&.MuiFormLabel-root.Mui-focused': {
            color: 'rgba(0, 0, 0, 0.87)',
        },
        '& .MuiTypography-body1': {
            fontSize: '14px',
        },
    },
})(FormLabel)

const SmallMyFormLabel = withStyles({
    root: {
        fontSize: '11px',
    },
})(MyFormLabel)

const MyRequiredChip = withStyles({
    root: {
        '&.MuiChip-root.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
            opacity: 1,
            borderColor: 'rgba(0, 0, 0, 0.38)',
        },
        '&.MuiChip-outlinedSecondary': {
            color: `#F50057`,
            borderColor: `#F50057`
        },
    },
})(RequiredChip)

const SubTableRowName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 130px;
  margin-right: 20px;
`

const MeetingAttachmentTableCell = withStyles({
    root: {
        padding: '20px 30px 20px 25px',
    },
})(TableCell)

const AddMeetingAttachmentTableCell = withStyles({
    root: {
        padding: '18px 12px 25px 25px',
    },
})(TableCell)

const circleIconStyle = {
    fontSize: '21px',
    color: Colors.AccentDark,
    marginRight: '8px',
}

const MeetingAttachmentItem = styled(TopRowFlexContainer)`
  margin-top: 8px;
  margin-left: 32px;
  min-height: 42px;
`

const GrowableFormControl = styled(FormControl)`
  flex-grow: 1;
`

const OnlineUrlItemName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100px;
  margin-right: 20px;
`
